import { DataBind } from "./DataBind.js";
import { getCallback } from "./utils.js";
class DataEffect extends DataBind {
  static config = {
    name: "DataEffect",
    options: {
      effect: String
    }
  };
  get effect() {
    const { group, effect } = this.$options;
    return getCallback(group, effect);
  }
  set(value) {
    try {
      this.effect(value, this.target);
    } catch (error) {
      console.error("Failed", error);
    }
  }
}
export {
  DataEffect
};
//# sourceMappingURL=DataEffect.js.map
